import React, { useEffect, useRef } from "react";

const TelegramLoginButton = ({ onAuth, botName, disabled = false }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.innerHTML = "";
    }

    if (!botName || disabled) return;

    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.setAttribute("data-telegram-login", botName);
    script.setAttribute("data-size", "large");
    script.setAttribute("data-userpic", "false");
    script.setAttribute("data-radius", "8");
    script.setAttribute("data-request-access", "write");
    script.async = true;

    window.onTelegramAuth = (user) => {
      if (onAuth) {
        onAuth(user);
      }
    };

    script.setAttribute("data-onauth", "onTelegramAuth(user)");

    if (containerRef.current) {
      containerRef.current.appendChild(script);
    }

    return () => {
      window.onTelegramAuth = undefined;
    };
  }, [botName, onAuth, disabled]);

  return (
    <div
      ref={containerRef}
      className={`flex justify-center ${disabled ? "pointer-events-none opacity-50" : ""}`}
    />
  );
};

export default TelegramLoginButton;
